import React, { useState } from 'react';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
import { Image } from 'components/common';

import { isCoverImage } from 'lib/media';

import ProductImage from '../ProductImage';
import * as typedef from '../typedef';
import useMediaQuery from 'hooks/useMediaQuery';

function ProductMedia(props) {
  const {
    product,
    adClass = 'product-gallery-vertical',
    thumbnailClass,
  } = props;

  const [photoIndex, setPhotoIndex] = useState(0);
  const [isOpen, setStatus] = useState(false);

  const { assets } = product;
  const coverImages = assets?.filter((asset) => isCoverImage(asset));

  function openLightBox() {
    setStatus(true);
  }

  function closeLightBox() {
    setStatus(false);
  }

  const getNextPhotoIndex = (photoIndex) =>
    (photoIndex + 1) % coverImages.length;

  const getPrevPhotoIndex = (photoIndex) =>
    (photoIndex + coverImages.length - 1) % coverImages.length;

  const setNextHandler = () => {
    setPhotoIndex((photoIndex) => getNextPhotoIndex(photoIndex));
  };

  const setPrevHandler = () => {
    setPhotoIndex((photoIndex) => getPrevPhotoIndex(photoIndex));
  };

  const isViewPortSmall = useMediaQuery('(max-width: 480px)');
  const isPointerCoarse = useMediaQuery('(pointer: coarse)');

  const isMobile = isViewPortSmall && isPointerCoarse;

  if (!product?.assets?.length)
    return (
      <Image
        src="/assets/images/No_image_available.svg"
        layout="fill"
      />
    );

  const currentPhoto = coverImages[photoIndex]?.url;
  const nextPhoto = coverImages[getNextPhotoIndex(photoIndex)]?.url;
  const prevPhoto = coverImages[getPrevPhotoIndex(photoIndex)]?.url;

  return (
    <div className={!isMobile && 'tw-sticky tw-top-[100px]'}>
      <div className={`product-gallery ${adClass}`}>
        <div className="row m-0">
          <figure className="product-main-image">
            {product.new ? (
              <span className="product-label label-new">New</span>
            ) : (
              ''
            )}

            {product.top ? (
              <span className="product-label label-top">Top</span>
            ) : (
              ''
            )}

            {product.discount ? (
              <span className="product-label label-sale">
                {product.discount}% off
              </span>
            ) : (
              ''
            )}

            {0 === product.stock ? (
              <span className="product-label label-out">
                Out of Stock
              </span>
            ) : (
              ''
            )}

            <ProductImage
              src={currentPhoto}
              alt={`${product?.name} main image`}
              size={450}
              layout="responsive"
            />

            <button
              id="btn-product-gallery"
              className="btn-product-gallery"
              onClick={openLightBox}
            >
              <i className="icon-arrows"></i>
            </button>
          </figure>

          <div
            id="product-zoom-gallery"
            className={`product-image-gallery ${thumbnailClass}`}
          >
            {coverImages.map((asset, index) => (
              <button
                className={`product-gallery-item ${
                  photoIndex === index ? 'active' : ''
                }`}
                key={product.id + '-' + index}
                onClick={() => setPhotoIndex(index)}
              >
                <ProductImage
                  src={asset.url}
                  alt={product.name}
                  layout="responsive"
                  size={100}
                />
              </button>
            ))}
          </div>
        </div>
      </div>

      {isOpen ? (
        <Lightbox
          mainSrc={currentPhoto}
          nextSrc={nextPhoto}
          prevSrc={prevPhoto}
          onCloseRequest={closeLightBox}
          onMovePrevRequest={setNextHandler}
          onMoveNextRequest={setPrevHandler}
        />
      ) : (
        ''
      )}
    </div>
  );
}

ProductMedia.propTypes = {
  product: typedef.Product,
};

export default ProductMedia;
